export default __webpack_public_path__ + "static/media/checked-circle.f79b114b.svg";